export const PYTHON_BACKEND_URL_STORAGE_KEY = "carousel_python_backend_url";
export function resolveBackendBaseUrl(defaultBaseUrl, storageKey) {
    try {
        const fromStorage = localStorage.getItem(storageKey);
        if (fromStorage && /^https?:\/\//i.test(fromStorage)) {
            return fromStorage;
        }
    }
    catch {
        // Ignore localStorage access issues.
    }
    return defaultBaseUrl;
}
export function resolvePythonBackendBaseUrl(defaultBaseUrl) {
    return resolveBackendBaseUrl(defaultBaseUrl, PYTHON_BACKEND_URL_STORAGE_KEY);
}
export function getResolvedPythonBackendUrl(defaultBaseUrl) {
    return resolvePythonBackendBaseUrl(defaultBaseUrl);
}
